import React from 'react'
import type { CharmSectionProps } from './types'
import styles from './Charm.module.css'

export default function CharmSection({
    title,
    description,
    className,
    id,
}: CharmSectionProps) {
    return (
        <div
            id={id}
            className={
                className ? `${styles.charmBg} ${className}` : styles.charmBg
            }
        >
            <div className={styles.charmBox}>
                <div className={styles.charmWhite}>
                    <h3>{title}</h3>
                    <p>{description}</p>
                </div>
            </div>
        </div>
    )
}
